<template>
  <div class="part">
    <div class="layout-page-heading">
      <div class="iconClock">
        <img src="../../assets/img/iconAccount.png" alt="">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>草稿箱</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="layout-page-box">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" height="600"
        :header-cell-style="{ color: '#626365' }">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="relationId" label="预约号"></el-table-column>
        <el-table-column prop="draftsTitle" label="预约信息"></el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
            <el-button size="mini" type="danger" @click="handleDel(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page"
        :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]"
        layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
    <!-- 修改草稿箱信息 -->
    <el-dialog :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
      <el-form :ref="form" :model="form" label-width="120px">
        <el-form-item label="客户姓名">
          <el-input v-model="form.customerName" style="width: 90%" clearable @input="testSX"> </el-input>
        </el-form-item>
        <el-form-item label="卡号" prop="cadCode">
          <el-input @input="testSX" v-model.trim="form.cadCode" style="width: 90%"
            onkeyup="this.value=this.value.replace(/[^\d.]/g,'');" clearable> </el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input @input="testSX" v-model.trim="form.mobile" style="width:80%"
            onkeyup="this.value=this.value.replace(/[^\d.]/g,'');" clearable> </el-input>
          <el-button class="info" type="primary" @click="getInfo" size="mini">获取信息</el-button>
        </el-form-item>
        <el-form-item label="预约门诊时间">
          <el-date-picker @input="testSX" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss"
            v-model="form.appointmentTime" type="datetime" placeholder="选择日期时间" style="width: 90%"
            :picker-options="disabledDate" @change="datepickChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="项目类型">
          <el-select v-model="form.projectType" placeholder="请选择项目类型" style="width:90%" @change="typeChange">
            <el-option v-for="item in projectTypeOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <div v-for="(item, index) in form.AppointmentProject" :key="index" class="formIndex">
          <div class="formTitle">
            <p>预约项目{{ index + 1 }}</p>
            <span type="text" @click="deleteItems(item, index)" icon="el-icon-close" v-show="index > 0"
              class="deleteButton"><i class="el-icon-close"></i></span>
          </div>
          <el-form-item label="院区/楼层">
            <el-select @input="testSX" :disabled="areaDisabled" @change="areaChange($event, index)"
              v-model="item.areaCode" placeholder="请选择院区" style="width: 45%">
              <el-option v-for="(item, index) in areaOptions" :key="index" :label="item.areaName" :value="item.areaCode">
              </el-option>
            </el-select>
            <el-select v-model="item.floorCode" :disabled='floorDisabled' placeholder="请选择楼层" style="width: 45%"
              @change="floorChange($event, index)">
              <el-option v-for="(item, index) in floorOptions" :key="index" :label="item.floorName"
                :value="item.floorCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预约项目" prop="projectName">
            <el-select v-model="item.projectId" @input="testSX" @change="projectChange($event, index)"
              @focus="projectFocusAdd($event, index)"
              :remote-method="(query) => { projectMethod(query, formTableLIst.projectType) }" filterable remote clearable
              placeholder="请输入搜索预约项目" style="width: 90%">
              <el-option v-for="item in projectOptions" :key="item.id" :label="item.projectName" :value="item.id"
                :disabled="item.disabled">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="宏脉项目名称" prop="hmProjectName">
            <el-input style="width: 90%" v-model="item.hmProjectName" disabled></el-input>
          </el-form-item>
          <el-form-item label="仪器" prop="instrumentId" class="instrumentName">
            <el-select @input="testSX" v-model="item.instrumentId" placeholder="请选择"
              @focus="instrumentFocus($event, index)" @change="instrumentChange($event, index)" style="width: 90%">
              <el-option v-for="(list, index) in item.projectInstrument" :key="index" :label="list.instrumentName"
                :value="list.instrumentId">
              </el-option>
            </el-select>
          </el-form-item>

          <div class="appointTime" v-if="item.showTime">
            <el-select :class="value == '1' ? 'tips' : 'tooltips'" v-model="value" style="width:160px;">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <div>
              <div class="appointTimeLong" v-if="value == '0'">
                <span v-for="(list, index) in item.successAppointTime.occupied" :key="index">
                  <el-tag type="danger">{{ list.instrumentDate }}</el-tag>
                </span>
              </div>
              <div class="appointTimeLong" v-if="value == '1'">
                <span v-for="(list, index) in item.successAppointTime.unoccupied" :key="index">
                  <el-tag>{{ list.instrumentDate }}</el-tag>
                </span>
              </div>
            </div>
          </div>

          <div v-for="(domain, idx) in item.appointmentPosition " :key="idx">
            <div class="instrucPosition">
              <el-form-item :label="'部位' + (idx + 1)">
                <el-select v-model="domain.positionId" @change="positionChange($event, index, idx)"
                  @focus="positionFocus($event, index)" clearable placeholder="请输入搜索部位" style="width:45%;"
                  @input="testSX">
                  <el-option v-for="(ite, index) in item.positionOptions" :key="index"
                    :label="ite.positionName + '~' + ite.useMinute + '分钟'" :value="ite.positionId"
                    :disabled="ite.disabled">
                  </el-option>
                </el-select>
                <el-time-select v-if="item.timeFlag" @input="testSX" @change="addDateChange($event, index, idx)"
                  v-model="domain.useTime" :picker-options="{ start: '09:00', step: '00:05', end: '23:00' }"
                  placeholder="选择仪器部位使用时间" @focus="onDateFocusTime($event, index)"></el-time-select>
                <el-time-select v-if="item.dateFlag" @input="testSX" @change="addDateChange($event, index, idx)"
                  v-model="domain.useTime" :picker-options="{ start: '08:00', step: '01:00', end: '23:00' }"
                  placeholder="选择仪器部位使用时间" @focus="onDateFocusTime($event, index)"></el-time-select>
                <el-button size="mini" type="danger" @click.prevent="removeDomain(domain, idx, index)" v-show="idx > 0">
                  <i class="el-icon-delete"></i>
                </el-button>
              </el-form-item>

            </div>
          </div>
          <el-form-item style="text-align: right;margin-right:5%;">
            <el-button @click="addDomain(index)" type="primary" size="mini">新增部位</el-button>
          </el-form-item>
          <el-form-item label="操作人" prop="doctorId">
            <el-select v-model="item.doctorId" placeholder="请选择" style="width: 90%" @change="docotrChange($event, index)"
              @focus="docotrFocus($event, index)">
              <el-option v-for="(list, index) in item.projectDoctor" :key="index" :label="list.doctorName"
                :value="list.doctorId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="初诊/复诊" prop="appointStatus">
            <el-select v-model="item.appointStatus" placeholder="请选择" style="width: 90%">
              <el-option v-for="option in typeOptions" :key="option.value" :label="option.text" :value="option.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input style="width: 90%" v-model="item.remark" type="textarea" autosize></el-input>
          </el-form-item>
        </div>
        <div class="clearBottom">
          <div class="partFooter">
            <el-button type="danger" @click="closs()">取 消</el-button>
            <el-button type="primary" @click="doAddgoods()">确 定</el-button>
            <el-button type="primary" round @click="addItem">添加预约</el-button>
            <el-button type="primary" round @click="addDarft">添加至草稿箱</el-button>
          </div>
        </div>
      </el-form>
    </el-dialog>
    <!-- 选择信息弹框 -->
    <el-dialog title="选择客户" append-to-body :visible.sync="dialogFormCheck" v-if="dialogFormCheck" center
      :close-on-click-modal="false">
      <info @close1="close1" :loadOptions="loadOptions" @sure="sure" :form="form"></info>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "member",
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else if (value.length != 11) {
        return callback(new Error('手机号长度不正确'));
      } else if (isNaN(value)) {
        return callback(new Error('手机号格式不正确'));
      }
    };
    return {
      dialogFormCheck: false,
      filters: {
        types: '',
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        },
        startTime: '',
        endTime: '',
      },
      form: {
        positionName: "",
      },
      tableData: [],
      multipleSelection: [],
      dialogFormVisible: false,
      value: true,
      rules: {
        mobile: [{
          validator: checkPhone,
          trigger: 'blur'
        }]
      },
      disabled: false,
      form: {
        positionName: "",
        AppointmentProject: [{
          projectName: "",
          instrumentName: "",
          doctorName: "",
          positionName: "",
          operationStatus: "",
          projectInstrument: [],
          projectDoctor: [],
          remark: "",
          showTime: false,
          successAppointTime: '',
          appointmentPosition: [{
            positionId: '',
            useTime: '',
            positionName: '',
          }],
          dateFlag: false,
          timeFlag: true,
        },],
      },
      areaOptions: [{
        areaName: '伯思立',
        areaCode: 'bsl'
      }, {
        areaName: '翡立思',
        areaCode: 'fls'
      }, {
        areaName: '南通伯思立',
        areaCode: 'ntbsl'
      }],
      floorOptions: [{
        floorName: '2楼',
        floorCode: '2'
      }, {
        floorName: '3楼',
        floorCode: '3'
      },
      {
        floorName: '12楼',
        floorCode: '12'
      },
      ],
      typeOptions: [{
        text: '初诊',
        value: 0
      },
      {
        text: '复诊',
        value: 1
      },
      {
        text: 'VIP',
        value: 2
      },
      ],
      optionsStatus: [{
        label: '待完成',
        value: 3
      },
      {
        label: '已取消',
        value: 1
      },
      {
        label: '已完成',
        value: 2
      },
      ],
      disabledDate: {
        disabledDate: (time) => {
          return time.getTime() < new Date().getTime() - 8.64e7
        },
      },
      floorOptions: [{
        floorName: '2楼',
        floorCode: '2'
      }, {
        floorName: '3楼',
        floorCode: '3'
      },
      {
        floorName: '12楼',
        floorCode: '12'
      },
      ],
      projectOptions: [],
      disabledDateNew: {},
      draftsId: '',
      options: [{
        value: '0',
        label: '当日已预约时间'
      }, {
        value: '1',
        label: '当日可预约时间'
      }],
      value: '1',
      projectTypeOptions: [{
        value: '1',
        label: '皮肤'
      }, {
        value: '2',
        label: '注射'
      }, {
        value: '3',
        label: '其他'
      }],
      dateFlag: false,
      timeFlag: true,
      areaType: Lockr.get("areaType"),
      cityCode: Lockr.get("cityCode"),
      floorDisabled: false,
      areaDisabled: true,
    }
  },
  created() {
    if (!this.areaType || this.areaType == undefined) {
      this.areaDisabled = false
    }
  },
  methods: {
    // 获取信息
    getInfo() {
      // this.form.customerName = ""
      if (this.form.cadCode == '' && this.form.mobile == '') {
        _g.toast("warning", '请填写手机号或卡号');
        return;
      }
      this.loadOption = []
      Lockr.set("selected", 1)
      this.loading = true
      let data = {
        clientCard: this.form.cadCode,
        clientMobile: this.form.mobile,
        clientName: this.form.customerName,
        pageIndex: 1,
      }
      api.requestQuiet("/register/getClientInformation", data, (res) => {
        console.log(res)
        if (res.result == true) {
          this.loading = false
          if (res.data.mapList.length == 1) {
            this.formData.mobile = res.data.mapList[0].clientMobile
            this.formData.cadCode = res.data.mapList[0].clientCard
            this.formData.customerName = res.data.mapList[0].clientName
            this.$forceUpdate()
          } else {
            this.dialogFormCheck = true
            this.loadOptions = res.data.mapList
          }
        } else {
          this.loading = false
          //   获取信息之后是否可以编辑信息
          this.disabled = false
          _g.toast("warning", '请手动添加客户信息');
        }
      }, (err) => {
        this.loading = false
      });
    },
    close1() {
      this.dialogFormCheck = false
    },
    sure(obj) {
      console.log(obj);
      this.dialogFormCheck = false
      //新增和修改弹框赋值
      this.form.customerName = obj.clientName
      this.form.mobile = obj.clientMobile
      this.form.cadCode = obj.clientCard
      //复制弹框赋值
      this.formTableLIst.customerName = obj.clientName
      this.formTableLIst.mobile = obj.clientMobile
      this.formTableLIst.cadCode = obj.clientCard
    },
    editDialog(arr) {
      this.dialogFormCheck = true
      this.loadOptions = arr
    },
    areaChange(val, index) {
      if (val == 'fls') {
        this.form.AppointmentProject[index].floorCode = '1'
        this.floorDisabled = true
        // this.form.AppointmentProject[index].disabled = true
        this.floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        }]
      } else if (val == 'bsl') {
        // this.form.AppointmentProject[index].disabled = false
        this.floorDisabled = false
        this.form.AppointmentProject[index].floorCode = ''
        this.floorOptions = [{
          floorName: '2楼',
          floorCode: '2'
        }, {
          floorName: '3楼',
          floorCode: '3'
        },
        {
          floorName: '12楼',
          floorCode: '12'
        },]
      } else if (val == 'ntbsl') {
        this.form.AppointmentProject[index].floorCode = '1'
        this.floorDisabled = true
        // this.form.AppointmentProject[index].disabled = true
        this.floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        }]
      }
      this.form.AppointmentProject[index].id = ''
      this.form.AppointmentProject[index].instrumentName = ''
      this.form.AppointmentProject[index].doctorName = ''
      this.form.AppointmentProject[index].appointmentPosition = [{
        positionId: '',
        useTime: '',
        positionName: '',
      }]
      this.form.AppointmentProject[index].positionOptions = []
      this.form.AppointmentProject[index].showTime = false
    },
    testSX() {
      this.$forceUpdate()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page
      this.refresh()
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes
      this.refresh()
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({}, this.$route.query, {
          __query: JSON.stringify(this.pagination)
        }, {
          random: Math.random()
        })
      })
    },
    // 新增时热拉提项目两小时时间制
    addDateChange(val, index, idx) {
      val = this.form.appointmentTime.split(' ')[0] + ' ' + val + ':00'
      if (this.form.AppointmentProject[index].instrumentName == '') {
        _g.toast("warning", "请先选择使用仪器")
        return;
      }
      var oDate1 = new Date(this.form.appointmentTime);
      var oDate2 = new Date(val);
      if (oDate1) {
        if (oDate1.getTime() > oDate2.getTime()) {
          _g.toast("warning", "预约仪器时间不得早于预约门诊时间");
          this.form.AppointmentProject[index].appointmentPosition[idx].useTime = ''
          this.$forceUpdate()
          return; //第一个大
        }
      }
      this.form.AppointmentProject[index].appointmentPosition[idx].useTime = val
      this.$forceUpdate()
    },
    onDateFocusTime(val, index) {
      this.form.AppointmentProject[index].doctorName = ''
      this.form.AppointmentProject[index].doctorId = ''
      this.form.AppointmentProject[index].listName3 = ''
      if (this.form.AppointmentProject[index].instrumentId == '') {
        _g.toast("warning", "请先选择使用仪器")
        return;
      }
    },
    datepickChange() {
      this.form.AppointmentProject.forEach(item => {
        console.log(item)
        item.doctorName = ''
        // item.projectDoctor = []
        item.instrumentName = ''
        // item.projectInstrument = []
        item.appointmentPosition = [{
          positionId: '',
          useTime: '',
          positionName: '',

        }]
        item.showTime = false,
          item.successAppointTime = '',
          item.positionOptions = []
      });
    },
    // 搜索查询全部可预约项目
    projectMethod(val) {
      let querys = {
        projectName: val,
        projectType: projectType,
        areaCode: this.areaType,
        cityCode: this.cityCode
      };
      api.request("/project/findProjectListByName", querys, (res) => {
        // console.log(res)
        if (res.data.length == 0) {
          _g.toast("warning", "还没有可选择的项目!");
        }
        this.projectOptions = res.data;
        this.form.AppointmentProject.map((x, i) => {
          this.projectOptions.map((s) => {
            if (x.id === s.id) {
              s.disabled = true
            }
          })
        })
        this.$forceUpdate()
      }, (err) => { });
    },
    // 编辑弹框查询项目
    projectFocus(val) {
      let querys = {
        projectName: "",
        projectType: this.form.projectType,
        areaCode: this.areaType,
        cityCode: this.cityCode
      };
      api.request("/project/findProjectListByName", querys, (res) => {
        // console.log(res)
        if (res.data.length == 0) {
          _g.toast("warning", "还没有可选择的项目!");
        }
        this.projectOptions = res.data;
      }, (err) => { });
    },
    // 删除草稿箱
    handleDel(index, row) {
      this.$confirm('确定要删除当条数据吗？', '删除草稿箱', {
        center: true
      })
        .then((res) => {
          api.requestQuiet("/appointment/deleteAppointmentDrafts", {
            draftsId: row.id,
          }, (res) => {
            if (res.result == true) {
              _g.toast("success", "删除成功")
              this.query()
            } else {
              _g.toast("error", "删除失败")
              this.query()
            }
          }, (err) => { })
        }).catch((err) => {
          // this.$message.error('删除失败！');
        })
    },
    // 修改草稿箱
    handleEdit(index, row) {
      this.$forceUpdate()
      this.dialogFormVisible = true
      this.draftsId = row.id

      api.requestQuiet("/appointment/findAppointmentDrafts", {
        relationId: row.relationId,
      }, (res) => {
        if (res.result == true) {
          this.form.mobile = res.data[0].mobile
          this.form.customerName = res.data[0].customerName
          this.form.appointmentTime = res.data[0].appointmentTime
          this.form.projectType = res.data[0].projectType
          this.form.AppointmentProject = res.data
          let newData = res.data

          newData.forEach(ele => {
            ele.id = ele.projectId
            if (ele.instrumentId != "" || ele.instrumentId != null) {
              ele.instrumentId = ele.instrumentId.slice(0, ele.instrumentId.length - 1)
            }
            if (ele.doctorId != "" || ele.doctorId != null) {
              ele.doctorId = parseInt(ele.doctorId.slice(0, ele.doctorId.length - 1))
            }

            // 回显时查询所有部位
            if (ele.instrumentId) {
              api.request("/instrument/findInstrumentById", {
                instrumentId: ele.instrumentId.split(',')[0]
              }, (res) => {
                this.$nextTick(() => {
                  ele.positionOptions = res.data.InstrumentPosition
                  ele.positionOptions.map((x, i) => {
                    ele.appointmentPosition.map((s) => {
                      if (x.positionId === s.positionId) {
                        x.disabled = true
                      }
                    })
                  })
                  this.$forceUpdate()
                });
              }, (err) => { })
            }

            // 回显查询部位以及医生接口
            if (ele.projectId) {
              let querys = {
                id: ele.projectId,
                areaCode: ele.areaCode,
                floorCode: ele.floorCode
              };
              api.request("/project/findProjectBydId", querys, (res) => {
                this.projectData = res.data
                // 新增时部位回显
                if (this.form.AppointmentProject) {
                  this.form.AppointmentProject.forEach(ele => {
                    if (ele.id == this.projectData.id) {
                      ele.projectInstrument = this.projectData.projectInstrument
                      ele.projectDoctor = this.projectData.projectDoctor
                      ele.projectDoctor.push({
                        doctorName: '无指定操作人',
                        doctorId: 999999,
                      })
                      ele.projectDoctorFilter = this.projectData.projectDoctor
                      ele.positionName = this.projectData.positionName
                      ele.positionId = this.projectData.positionId
                      ele.projectName = this.projectData.projectName
                      ele.hmProjectName = this.projectData.hmProjectName
                      ele.operationStatus = 3
                      ele.projectInstrument.forEach(item => {
                        if (ele.instrumentId == item.instrumentId) {
                          ele.instrumentName = item.instrumentName
                        }
                      });
                      if (ele.doctorId == 0) {
                        ele.doctorId = ''
                      }
                      ele.projectDoctor.forEach(item => {
                        if (ele.doctorId == item.doctorId) {
                          ele.doctorName = item.doctorName
                        }
                      });
                    }
                  });
                }
                console.log(this.form.AppointmentProject)
                this.$forceUpdate()
              });
            }


            ele.appointmentPosition = []
            if (ele.appointStatus == 2) {
              ele.appointStatusList = 'VIP'
            } else if (ele.appointStatus == 1) {
              ele.appointStatusList = '复诊'
            } else if (ele.appointStatus == 0) {
              ele.appointStatusList = '初诊'
            }


            if (ele.positionId != '') {
              let newStr = ele.positionId.slice(0, ele.positionId.length - 1)
              let newArr = newStr.split(',')
              newArr.forEach((ite, index) => {
                let str = ite.split('_')
                // console.log(str)
                var obj = {}
                obj.positionId = str[0]
                obj.positionName = str[1]
                obj.useTime = str[2]
                obj.positionNameTime = str[1] + '(' + str[2].split(' ')[1] + ')'
                ele.appointmentPosition.push(obj)
              });
            }
            let ss = ele.projectName.includes('热拉提')
            let vv = ele.projectName.includes('热玛吉')
            if (ss == true || vv == true) {
              ele.dateFlag = true
              ele.timeFlag = false
            } else {
              ele.dateFlag = false
              ele.timeFlag = true
            }

            // 根据预约门诊时间和仪器id提示仪器已预约时间
            let queryData = {
              appointmentTime: this.form.appointmentTime,
              instrumentId: ele.instrumentId,
            }
            api.request("/appointment/findInstrumentDateById", queryData, (res) => {
              if (res.result == true) {
                let dataTimeAppoint = res.data
                if (dataTimeAppoint.unoccupied) {
                  ele.showTime = true
                  ele.successAppointTime = dataTimeAppoint
                } else if (!dataTimeAppoint.unoccupied) {
                  ele.showTime = false
                }
              }
              this.$forceUpdate()
            }, (err) => { });


            ele.list1 = [{
              instrumentId: ele.instrumentId,
            }]

            ele.list2 = [{
              doctorId: ele.doctorId
            }]
            ele.listName3 = ele.doctorName
            ele.listName4 = ele.instrumentName

          });
        }
      }, (err) => { })
      this.projectFocus()

      if (this.areaType == 'fls') {
        this.form.AppointmentProject.forEach(item => {
          item.floorCode = '1'
          // item.disabled = true
        });
        this.floorDisabled = true
        this.floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        }]
      } else if (this.areaType == 'bsl') {
        this.floorDisabled = false
        this.floorOptions = [{
          floorName: '2楼',
          floorCode: '2'
        }, {
          floorName: '3楼',
          floorCode: '3'
        }, {
          floorName: '12楼',
          floorCode: '12'
        },]
      } else if (this.areaType == 'ntbsl') {
        this.form.AppointmentProject.forEach(item => {
          item.floorCode = '1'
          // item.disabled = true
        });
        this.floorDisabled = true
        this.floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        }]
      }
    },
    closs() {
      this.dialogFormVisible = false
    },
    // 再次添加至草稿箱
    addDarft() {
      this.$forceUpdate()
      if (!this.form.customerName || this.form.customerName == "") {
        _g.toast("warning", "请填写顾客名称");
        return;
      }
      if (!this.form.mobile || this.form.mobile == "") {
        _g.toast("warning", "请填写电话号码");
        return;
      }
      if (!this.form.appointmentTime || this.form.appointmentTime == "") {
        _g.toast("warning", "请填写预约时间");
        return;
      }
      let empId = Lockr.get("empId");
      this.form.userId = empId
      this.form.draftsId = this.draftsId

      // 添加医生以及仪器Id
      this.form.AppointmentProject.forEach(item => {

        if (item.doctorId == '0') {
          item.projectDoctor = [
            { doctorId: '' }
          ]
        } else {
          item.projectDoctor = [
            { doctorId: item.doctorId }
          ]
        }
        item.projectInstrument = [
          { instrumentId: item.instrumentId }
        ]
        item.id = item.projectId
      });

      // 添加院区以及楼层参数名
      this.areaOptions.forEach(ele => {
        this.form.AppointmentProject.forEach(item => {
          if (item.areaCode == ele.areaCode) {
            item.areaName = ele.areaName
          }
        });
      });
      this.floorOptions.forEach(ele => {
        this.form.AppointmentProject.forEach(item => {
          if (item.floorCode == ele.floorCode) {
            item.floorName = ele.floorName
          }
        });
      });
      this.$forceUpdate()
      this.form.areaType = this.areaType
      this.form.areaCode = this.areaType
      console.log('最后提交的数据this.form')
      console.log(this.form)
      api.request("/appointment/saveAppointmentDrafts", this.form, (res) => {
        this.$nextTick(() => {
          _g.toast("success", "草稿箱添加成功！");
          this.dialogFormVisible = false
          this.query();
          this.$forceUpdate()
        });
      }, (err) => { })
    },
    // 确定新增
    doAddgoods() {

      if (!this.form.customerName || this.form.customerName == '') {
        _g.toast("warning", "请填写顾客名称")
        return;
      }
      if (!this.form.mobile || this.form.mobile == '') {
        _g.toast("warning", "请填写电话号码")
        return;
      }
      if (!this.form.appointmentTime || this.form.appointmentTime == '') {
        _g.toast("warning", "请填写预约时间")
        return;
      }
      let empId = Lockr.get("empId");
      this.form.userId = empId
      this.form.draftsId = this.draftsId
      // 添加医生以及仪器Id

      let data = JSON.parse(JSON.stringify(this.form))
      if (data.AppointmentProject) {
        data.AppointmentProject.forEach(ele => {
          ele.projectInstrument = ele.list1
          ele.projectDoctor = ele.list2
          ele.doctorName = ele.listName3
          ele.instrumentName = ele.listName4
          ele.id = ele.projectId
        });
      }
      // 添加院区以及楼层参数名
      this.areaOptions.forEach(ele => {
        this.form.AppointmentProject.forEach(item => {
          if (item.areaCode == ele.areaCode) {
            item.areaName = ele.areaName
          }
        });
      });
      this.floorOptions.forEach(ele => {
        this.form.AppointmentProject.forEach(item => {
          if (item.floorCode == ele.floorCode) {
            item.floorName = ele.floorName
          }
        });
      });
      data.areaCode = this.areaType
      console.log(data)
      // 新增项目接口
      api.requestQuiet("/appointment/insertOrUpdateAppointment", data, (res) => {
        if (res.result == true) {
          this.dialogFormVisible = false;
          if (res.data != '') {
            _g.toast("success", res.data);
          }
          this.query();
        } else {
          _g.toast("error", res.errMsg);
          this.query();
        }
      }, (err) => { });
    },
    addItem() {
      this.form.AppointmentProject.push({
        projectName: "",
        instrumentName: "",
        doctorName: "",
        positionName: "",
        key: Date.now(),
        projectInstrument: [],
        projectDoctor: [],
        operationStatus: "",
        remark: "",
        instrumentId: '',
        doctorId: '',
        id: '',
        showTime: false,
        successAppointTime: '',
        appointmentPosition: [{
          positionId: '',
          useTime: '',
          positionName: '',

        }],
        timeFlag: true,
        dateFlag: false
      });
      this.$forceUpdate()
    },
    // 新增时项目类型发生改变清空值
    typeChange() {
      this.form.AppointmentProject = [{
        projectName: "",
        instrumentName: "",
        doctorName: "",
        operationStatus: "",
        appointStatus: "",
        projectInstrument: [],
        projectDoctor: [],
        remark: "",
        positionNameTime: '',
        appointmentPosition: [{
          positionId: '',
          useTime: '',
          positionName: '',
          positionNameTime: '',
        }],
        dateFlag: false,
        timeFlag: true,
      },]
    },
    // 新增弹框查询项目
    projectFocusAdd(val, index) {
      // 查询项目之前先判断预约门诊时间是否填写
      if (this.form.appointmentTime == '' || this.form.appointmentTime == undefined) {
        _g.toast("warning", "请先选择预约门诊时间");
        return;
      }
      if (this.form.projectType == '' || this.form.projectType == undefined) {
        _g.toast("warning", "请先选择项目类型");
        return;
      }
      if (this.form.AppointmentProject[index].areaCode == '' || this.form.AppointmentProject[index].areaCode ==
        undefined) {
        _g.toast("warning", "请先选择院区");
        return;
      }
      if (this.form.AppointmentProject[index].floorCode == '' || this.form.AppointmentProject[index].floorCode ==
        undefined) {
        _g.toast("warning", "请先选择楼层");
        return;
      }
      let querys = {
        projectName: "",
        projectType: this.form.projectType,
        areaCode: this.areaType,
        cityCode: this.cityCode
      };
      api.request("/project/findProjectListByName", querys, (res) => {
        // console.log(res)
        if (res.data.length == 0) {
          _g.toast("warning", "还没有可选择的项目!");
        }
        this.projectOptions = res.data;
        this.form.AppointmentProject.map((x, i) => {
          this.projectOptions.map((s) => {
            if (x.id === s.id) {
              s.disabled = true
            }
          })
          this.$forceUpdate()
        })
      }, (err) => { });
      this.form.AppointmentProject[index].instrumentName = ''
      this.form.AppointmentProject[index].instrumentId = ''
      this.form.AppointmentProject[index].doctorName = ''
      this.form.AppointmentProject[index].doctorId = ''
      this.form.AppointmentProject[index].showTime = false
      this.form.AppointmentProject[index].successAppointTime = ''
      this.form.AppointmentProject[index].appointmentPosition = [{
        positionId: '',
        useTime: '',
        positionName: '',
      }]
      this.form.AppointmentProject[index].positionOptions = []
    },
    onFocusTime(val, index) {
      this.disabledDateNew = {
        disabledDate: (time) => {
          let disable = time.getTime() > new Date(this.form.appointmentTime).getTime() || time.getTime() <
            new Date(
              this.form.appointmentTime).getTime() - 8.64e7
          return disable
        },
      }
      this.form.AppointmentProject[index].doctorName = ''
      this.form.AppointmentProject[index].listName3 = ''
      if (this.form.AppointmentProject[index].instrumentId == '') {
        _g.toast("warning", "请先选择使用仪器")
        return;
      }
    },
    // 新增时楼层改变的操作
    floorChange(val, index) {
      console.log(val, index)
      this.form.AppointmentProject[index].id = ''
      this.form.AppointmentProject[index].instrumentName = ''
      this.form.AppointmentProject[index].doctorName = ''
      this.form.AppointmentProject[index].successAppointTime = ''
      this.form.AppointmentProject[index].showTime = false
      this.form.AppointmentProject[index].appointmentPosition = [{
        positionId: '',
        useTime: '',
        positionName: '',
      }]
      this.form.AppointmentProject[index].positionOptions = []
    },
    instrumentFocus(val, index) {
      if (this.form.AppointmentProject[index].projectId == '') {
        _g.toast("warning", "请先选择预约项目")
        return;
      }
      this.$forceUpdate()
    },
    instrumentChange(val, index) {
      this.arrList1 = val
      this.form.AppointmentProject.forEach(ele => {
        if (ele.id == this.form.AppointmentProject[index].id) {
          this.form.AppointmentProject[index].list1 = [{
            instrumentId: this.arrList1,
          }]
          this.form.AppointmentProject[index].projectInstrument.forEach(item => {
            if (item.instrumentId == val) {
              this.form.AppointmentProject[index].listName4 = item.instrumentName
              this.form.AppointmentProject[index].instrumentName = item.instrumentName
            }
          });
        }
        this.form.AppointmentProject[index].appointmentPosition = [{
          positionId: '',
          useTime: '',
          positionName: ''
        }]
        this.form.AppointmentProject[index].list2 = ''
        this.form.AppointmentProject[index].doctorName = ''
        console.log(this.form.AppointmentProject[index])
      });
      // 根据预约门诊时间和仪器id提示仪器已预约时间
      let queryData = {
        appointmentTime: this.form.appointmentTime,
        instrumentId: this.form.AppointmentProject[index].instrumentId.split(',')[0],
      }
      api.request("/appointment/findInstrumentDateById", queryData, (res) => {
        if (res.result == true) {
          let dataTimeAppoint = res.data
          if (dataTimeAppoint.unoccupied) {
            this.form.AppointmentProject[index].showTime = true
            this.form.AppointmentProject[index].successAppointTime = dataTimeAppoint
          } else if (!dataTimeAppoint.unoccupied) {
            this.form.AppointmentProject[index].showTime = false
          }
        }
        this.$forceUpdate()
      });
      this.$forceUpdate()
    },
    positionFocus(val, index) {
      console.log(this.form.AppointmentProject[index])
      if (this.form.AppointmentProject[index].instrumentId == '') {
        _g.toast("warning", "请先选择仪器");
        return;
      }
      api.request("/instrument/findInstrumentById", {
        instrumentId: this.form.AppointmentProject[index].instrumentId.split(',')[0]
      }, (res) => {
        this.$nextTick(() => {
          this.form.AppointmentProject[index].positionOptions = res.data.InstrumentPosition
          this.form.AppointmentProject[index].positionOptions.map((x, i) => {
            this.form.AppointmentProject[index].appointmentPosition.map((s) => {
              if (x.positionId === s.positionId) {
                x.disabled = true
              }
            })
          })
          this.$forceUpdate()
        });
      }, (err) => { })
    },
    // // 新增操作根据选中的项目id查询可用仪器操作人等
    projectChange(val, index) {
      console.log(val, index)
      let querys = {
        id: val,
        areaCode: this.form.AppointmentProject[index].areaCode,
        floorCode: this.form.AppointmentProject[index].floorCode
      };
      api.request("/project/findProjectBydId", querys, (res) => {
        this.projectData = res.data
        // 新增时部位回显
        if (this.form.AppointmentProject) {
          this.form.AppointmentProject.forEach(ele => {
            // if (ele.id == this.projectData.id) {
            console.log(this.projectData.projectInstrument)
            this.form.AppointmentProject[index].projectInstrument = this.projectData.projectInstrument
            this.form.AppointmentProject[index].projectDoctorFilter = this.projectData.projectDoctor
            ele.positionName = this.projectData.positionName
            ele.positionId = this.projectData.positionId
            ele.projectName = this.projectData.projectName
            ele.hmProjectName = this.projectData.hmProjectName
            ele.operationStatus = 3
            this.$forceUpdate()
          });
        }
        // 项目时间两小时制分类
        let ss = this.projectData.projectName.includes('热拉提')
        let vv = this.projectData.projectName.includes('热玛吉')
        this.form.AppointmentProject[index].dateFlag = false
        this.form.AppointmentProject[index].timeFlag = true
        if (ss == true || vv == true) {
          this.form.AppointmentProject[index].dateFlag = true
          this.form.AppointmentProject[index].timeFlag = false
        } else {
          this.form.AppointmentProject[index].dateFlag = false
          this.form.AppointmentProject[index].timeFlag = true
        }
      }, (err) => { });
    },
    positionChange(val, index, idx) {
      console.log(this.form)
      console.log(this.form.AppointmentProject[index])
      this.form.AppointmentProject[index].appointmentPosition[idx].positionId = val
      this.form.AppointmentProject[index].positionOptions.forEach(ele => {
        if (val == ele.positionId) {
          this.form.AppointmentProject[index].appointmentPosition[idx].positionName = ele.positionName
        }
      });
      api.request("/instrument/findInstrumentById", {
        instrumentId: this.form.AppointmentProject[index].instrumentId.split(',')[0],
      }, (res) => {
        this.$nextTick(() => {
          this.form.AppointmentProject[index].positionOptions = res.data.InstrumentPosition
          this.form.AppointmentProject[index].positionOptions.map((x, i) => {
            this.form.AppointmentProject[index].appointmentPosition.map((s) => {
              if (x.positionId === s.positionId) {
                x.disabled = true
              }
            })
          })
          this.$forceUpdate()
        });
      }, (err) => { })
    },
    // 判断仪器选择时间
    onBlurTime(val, index, idx) {
      if (this.form.AppointmentProject[index].instrumentId == '') {
        _g.toast("warning", "请先选择使用仪器")
        return;
      }
      var oDate1 = new Date(this.form.appointmentTime);
      var oDate2 = new Date(val.value);
      if (oDate1) {
        if (oDate1.getTime() > oDate2.getTime()) {
          _g.toast("warning", "预约仪器时间不得早于预约门诊时间");
          this.form.AppointmentProject[index].appointmentPosition[idx].useTime = ''
          return; //第一个大
        }
      }
    },
    onFocusTime(val, index) {
      this.disabledDateNew = {
        disabledDate: (time) => {
          let disable = time.getTime() > new Date(this.form.appointmentTime).getTime() || time.getTime() <
            new Date(
              this.form.appointmentTime).getTime() - 8.64e7
          return disable
        },
      }
      this.form.AppointmentProject[index].doctorName = ''
      this.form.AppointmentProject[index].doctorId = ''
      this.form.AppointmentProject[index].listName3 = ''
      if (this.form.AppointmentProject[index].instrumentId == '') {
        _g.toast("warning", "请先选择使用仪器")
        return;
      }

    },
    addDomain(index) {
      this.form.AppointmentProject[index].appointmentPosition.push({
        positionId: '',
        positionName: '',
        useTime: '',
        key: Date.now()
      });
      this.$forceUpdate()
    },
    // 新增时筛选操作人
    docotrFocus(val, index) {
      console.log(this.form.AppointmentProject[index])
      if (!this.form.AppointmentProject[index].appointmentPosition[0].useTime) {
        _g.toast("warning", "请先选择仪器预约时间");
        return;
      }
      // 根据选择仪器时间筛选操作人
      let arrForm = []
      this.form.AppointmentProject[index].projectDoctorFilter.forEach(ele => {
        arrForm.push(ele.doctorId)
      });
      let queryData = {
        appointmentTime: this.form.appointmentTime,
        doctorIds: arrForm,
        instrumentId: this.form.AppointmentProject[index].instrumentId,
        appointmentPosition: this.form.AppointmentProject[index].appointmentPosition
      }
      api.request("/appointment/findDoctorByInstrumentDate", queryData, (res) => {
        if (res.result == true) {
          let resData = res.data
          // 筛选id相同的医生数据
          if (resData.length != 0) {
            let add = this.form.AppointmentProject[index].projectDoctorFilter.filter(item => resData.some(ele =>
              ele.doctorId === item.doctorId))
            add.push({
              doctorId: '999999',
              doctorName: '无指定操作人'
            })
            this.form.AppointmentProject[index].projectDoctor = add
          } else if (resData.length == 0) {
            this.form.AppointmentProject[index].projectDoctor = [{
              doctorId: '999999',
              doctorName: '无指定操作人'
            }]
            console.log(this.form.AppointmentProject[index].projectDoctor)
          }
        }
        this.$forceUpdate()
      }, (err) => { });
    },
    docotrChange(val, index) {
      this.arrList2 = val
      this.form.AppointmentProject.forEach(ele => {
        if (ele.id == this.form.AppointmentProject[index].id) {
          this.form.AppointmentProject[index].list2 = [{
            doctorId: this.arrList2
          }]
          this.form.AppointmentProject[index].projectDoctor.forEach(item => {
            if (item.doctorId == val) {
              console.log('item.doctorName')
              console.log(item.doctorName)
              this.form.AppointmentProject[index].listName3 = item.doctorName
              this.form.AppointmentProject[index].doctorName = item.doctorName
            }
          });
        }
      });
    },
    removeDomain(item, idx, listIndex) {
      var index = this.form.AppointmentProject[listIndex].appointmentPosition.indexOf(item)
      if (index !== -1) {
        this.form.AppointmentProject[listIndex].appointmentPosition.splice(idx, 1)
      }
      this.$forceUpdate()
    },
    // 查询数据列表
    query() {
      let empId = Lockr.get("empId")
      // console.log(this.filters.startTime)
      var querys = {
        accountName: this.filters.account,
        departmentId: this.filters.departmentId,
        page: this.filters.pagination.page,
        size: this.filters.pagination.limit,
        userId: empId,
        areaType: Lockr.get("areaType"),
        areaCode: Lockr.get("areaType")
      }
      api.requestQuiet('/appointment/findAppointmentDraftsList', querys, (res) => {
        // console.log(res)
        var data = res.data.list
        this.tableData = data
        this.orgData = data
        this.filters.pagination.total = parseInt(res.data.total)
      }, (err) => { })
    },
    deleteItems(item, index) {
      this.index = this.form.AppointmentProject.indexOf(item);
      if (index !== -1) {
        this.form.AppointmentProject.splice(index, 1);
      }
    },
  },
  mounted() {
    /*this.init();*/
    this.query()
  },
  watch: {
    '$route'(to, from) {
      this.query()
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/main.css";

.part>>>.el-dialog--center .el-dialog__body {
  text-align: center;
}

.formTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  box-sizing: border-box;
}

.dialogItem>>>.el-input__inner {
  height: 34px;
  background: #ffffff;
  /* box-shadow: 0px 0px 5px 3px #CAEAFD; */
  border-radius: 3px;
  /* border: 1px solid #23A2EE; */
}

.dialogItem>>>.el-form-item__label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #626365;
}

.partFooter>>>.el-button--primary {
  width: 125px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.checkButton>>>.el-button--primary {
  width: 98px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.partFooter>>>.el-button--danger {
  width: 125px;
  height: 34px;
  border-radius: 17px;
  border: 1px solid #5a7ef8;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5a7ef8;
  line-height: 2px;
  background: none;
}

.pageInput>>>.el-input__inner {
  width: 400px;
  height: 38px;
  background: #f6f7fb;
  border-radius: 23px;
  border: none;
}

.pageInput>>>.el-button {
  height: 34px;
  border-radius: 17px;
  border: 1px solid #979797;
  line-height: 5px;
  margin-left: 8px;
}

.part>>>.el-card {
  width: 360px;
  /* height: 160px; */
}

.iconClock {
  display: flex;
  align-items: center;
}

.iconClock img {
  height: 20px;
  margin-right: 5px;
}

.part>>>.el-select .el-input.is-disabled .el-input__inner {
  color: #606266;
}

.appointTime {
  display: flex;
  margin-left: 10%;
  margin-bottom: 30px;
}

.tips>>>.el-input__inner {
  background-color: #ecf5ff;
  border-color: #d9ecff;
  color: #409eff;
  width: 155px;
}

.tooltips>>>.el-input__inner {
  background-color: #fef0f0;
  border-color: #fde2e2;
  color: #f56c6c;
  width: 155px;
}

.appointTimeLong {
  text-align: left;
  margin-left: 5%;
  width: 400px;
}

.appointTimeLong>>>.el-tag {
  margin-bottom: 10px;
  margin-right: 10px;
}

.tips>>>.el-icon-arrow-up:before {
  color: #409eff;
}

.tooltips>>>.el-icon-arrow-up:before {
  color: #f56c6c;
}
</style>